<script>
  import Member from '../utility/Member.svelte'
  import Page from 'page'

  let checkLocalStorage = localStorage.getItem('loginData')

  if (checkLocalStorage) {
    localStorage.clear()
  }
</script>

<Member />

<style lang="scss">
</style>
